/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1WireEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_WIRE_EVENT_ENTITY_NAME = 'exc.increase.v1.WireEvent';
export const excIncreaseV1WireEventEntity = new schema.Entity<ExcIncreaseV1WireEvent>(EXC_INCREASE_V1_WIRE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIncreaseV1WireEvent) => `${entity.metadata?.eventId}` });

